import TodoServices from 'services/todo/TodoServices';

const clearTodosUseCase = (todoServices: TodoServices) => async () => {
  await todoServices.clear();
};

export default clearTodosUseCase;
